var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "page-title" }, [_vm._v("素材管理")]),
    _vm._v(" "),
    _c(
      "h4",
      { staticClass: "breadcrumb-c" },
      [
        _c(
          "router-link",
          {
            staticClass: "back-btn",
            attrs: {
              to: {
                name: "material",
                query: {
                  type: 4
                }
              }
            }
          },
          [_c("i", { staticClass: "fa fa-angle-left" }), _vm._v(" 语音 ")]
        ),
        _vm._v("/ 新建语音\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "form-horizontal form form-create",
        attrs: { role: "form" }
      },
      [
        _c("div", { staticClass: "form-body" }, [
          _c("div", { staticClass: "form-group" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c(
                  "p",
                  {
                    staticClass: "form-control-static",
                    staticStyle: { color: "#888" }
                  },
                  [
                    _vm._v(
                      "\n            格式支持mp3、wma、wav、amr，文件大小不超过10M，建议时长不超过15分钟\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("c-file-upload", {
                  attrs: { config: _vm.content },
                  on: {
                    "update:config": function($event) {
                      _vm.content = $event
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "p",
                {
                  staticClass: "form-control-static",
                  staticStyle: { color: "#888" }
                },
                [_vm._v("\n            该标题将会在AR扫描界面显示\n          ")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  },
                  { name: "maxlength", rawName: "v-maxlength" }
                ],
                staticClass: "form-control",
                attrs: { maxlength: "24" },
                domProps: { value: _vm.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-8" },
              [
                _c("c-file-upload", {
                  attrs: { config: _vm.cover },
                  on: {
                    "update:config": function($event) {
                      _vm.cover = $event
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "col-sm-1 control-label" }, [
              _vm._v("分组")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gid,
                      expression: "gid"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.gid = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "ungroup" } }, [
                    _vm._v("未分组")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.groups, function(g) {
                    return [
                      _c("option", { domProps: { value: g.objectId } }, [
                        _vm._v(_vm._s(g.title))
                      ])
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-1 control-label",
                staticStyle: { "vertical-align": "top" }
              },
              [_vm._v("简介")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.about,
                    expression: "about"
                  },
                  { name: "maxlength", rawName: "v-maxlength" }
                ],
                staticClass: "form-control",
                attrs: { rows: "3", maxlength: "1000" },
                domProps: { value: _vm.about },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.about = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4)
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-actions",
            staticStyle: { "margin-left": "20px", "margin-right": "20px" }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-12",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn m-green",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [_vm._v("\n            保存\n          ")]
                  )
                ]
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "control-label col-sm-1",
        staticStyle: { "padding-right": "0" }
      },
      [
        _c("span", { staticClass: "required" }, [_vm._v(" * ")]),
        _vm._v("上传音频")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-sm-1 control-label" }, [
      _c("span", { staticClass: "required" }, [_vm._v(" * ")]),
      _vm._v("标题")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "control-label col-sm-1" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _vm._v("封面\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c(
        "div",
        { staticClass: "col-sm-12", staticStyle: { "text-align": "center" } },
        [
          _c(
            "p",
            {
              staticClass: "form-control-static",
              staticStyle: { color: "#888" }
            },
            [
              _vm._v(
                "\n            不得上传未经授权的他人作品，以及色情、反动等违法视频。\n          "
              )
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "div",
          {
            staticClass: "checkbox-list",
            staticStyle: { "text-align": "center" }
          },
          [
            _c("label", { staticClass: "checkbox-inline" }, [
              _vm._v("\n              我已同意并阅读\n              "),
              _c(
                "a",
                {
                  staticStyle: { color: "#4a90e2" },
                  attrs: { href: "/web-mgr/media/agreement", target: "_blank" }
                },
                [_vm._v("《视网么音视频上传规则》")]
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }